<app-side-bar></app-side-bar>
<app-settings-modal></app-settings-modal>
<app-nav-bar></app-nav-bar>

<main class="reports-page">
  <section class="reports-header">
    <div>
      <h1>{{ 'REPORTS_TITLE' | translate }}</h1>
      <p>{{ 'REPORTS_SUBTITLE' | translate }}</p>
    </div>
  </section>

  <section class="reports-card" aria-labelledby="sales-export-title">
    <div class="section-title">
      <h2 id="sales-export-title">{{ reportTitleKey | translate }}</h2>
    </div>

    <form [formGroup]="filtersForm" (ngSubmit)="loadReport()" class="filters-form" novalidate>
      <div class="filters-grid">
        <div class="field">
          <label for="report-type">{{ 'REPORT_TYPE' | translate }}</label>
          <select id="report-type" class="form-select" formControlName="reportType" [disabled]="isLoading || isGenerating" (change)="onReportTypeChange($any($event.target).value)">
            <option *ngFor="let type of reportTypeOptions" [value]="type.id">{{ type.labelKey | translate }}</option>
          </select>
        </div>

        <ng-container *ngIf="isSalesReport">
          <div class="field">
            <label for="report-start-date">{{ 'START_DATE' | translate }}</label>
            <input id="report-start-date" class="form-control" type="date" formControlName="startDate" [disabled]="isLoading" />
          </div>

          <div class="field">
            <label for="report-end-date">{{ 'END_DATE' | translate }}</label>
            <input id="report-end-date" class="form-control" type="date" formControlName="endDate" [disabled]="isLoading" />
            <small class="field-error" *ngIf="hasFormError('dateRange')">{{ 'REPORT_DATE_RANGE_ERROR' | translate }}</small>
          </div>

          <div class="field">
            <label for="report-min-amount">{{ 'MIN_AMOUNT' | translate }}</label>
            <input id="report-min-amount" class="form-control" type="number" min="0" formControlName="minAmount" [disabled]="isLoading" />
            <small class="field-error" *ngIf="hasFieldError('minAmount', 'nonNegative') || hasFieldError('minAmount', 'number')">{{ 'REPORT_AMOUNT_NEGATIVE_ERROR' | translate }}</small>
          </div>

          <div class="field">
            <label for="report-max-amount">{{ 'MAX_AMOUNT' | translate }}</label>
            <input id="report-max-amount" class="form-control" type="number" min="0" formControlName="maxAmount" [disabled]="isLoading" />
            <small class="field-error" *ngIf="hasFieldError('maxAmount', 'nonNegative') || hasFieldError('maxAmount', 'number')">{{ 'REPORT_AMOUNT_NEGATIVE_ERROR' | translate }}</small>
            <small class="field-error" *ngIf="hasFormError('amountRange')">{{ 'REPORT_AMOUNT_RANGE_ERROR' | translate }}</small>
          </div>

          <div class="field field--wide">
            <label for="report-search">{{ 'SEARCH' | translate }}</label>
            <input id="report-search" class="form-control" type="text" formControlName="searchString" [placeholder]="'REPORT_SEARCH_PLACEHOLDER' | translate" [disabled]="isLoading" />
          </div>
        </ng-container>

        <div class="field" *ngIf="isActivePlansReport">
          <label for="report-billing-period">{{ 'BILLING_PERIOD' | translate }}</label>
          <input id="report-billing-period" class="form-control" type="month" formControlName="billingPeriod" [disabled]="isLoading || isGenerating" (change)="onBillingPeriodChange()" />
          <small class="field-error" *ngIf="hasBillingPeriodError">{{ 'REPORT_BILLING_PERIOD_REQUIRED' | translate }}</small>
        </div>
      </div>

      <button
        type="button"
        class="additional-toggle"
        *ngIf="isSalesReport"
        (click)="showAdditionalFilters = !showAdditionalFilters"
        [attr.aria-expanded]="showAdditionalFilters"
        aria-controls="report-additional-filters"
      >
        <i class="bi bi-sliders" aria-hidden="true"></i>
        <span>{{ 'REPORT_ADDITIONAL_FILTERS' | translate }}</span>
        <i class="bi" [ngClass]="showAdditionalFilters ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
      </button>

      <div id="report-additional-filters" class="filters-grid additional-filters" *ngIf="isSalesReport && showAdditionalFilters">
        <div class="field">
          <label for="report-sale-state">{{ 'ORDER_STATUS' | translate }}</label>
          <select id="report-sale-state" class="form-select" formControlName="saleState" [disabled]="isLoading">
            <option *ngFor="let state of saleStateOptions" [ngValue]="state.id">{{ state.name }}</option>
          </select>
        </div>

        <div class="field" *ngIf="paymentTypes.length">
          <label for="report-payment-type">{{ 'PAYMENT_TYPE' | translate }}</label>
          <select id="report-payment-type" class="form-select" formControlName="paymentTypeId" [disabled]="isLoading">
            <option value="">{{ 'ALL' | translate }}</option>
            <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType.id">{{ paymentType.name }}</option>
          </select>
        </div>

        <div class="field" *ngIf="shopPoints.length">
          <label for="report-shop-point">{{ 'POINTS_OF_SALE' | translate }}</label>
          <select id="report-shop-point" class="form-select" formControlName="shopPointId" [disabled]="isLoading">
            <option value="">{{ 'ALL' | translate }}</option>
            <option *ngFor="let shopPoint of shopPoints" [ngValue]="shopPoint.id">{{ shopPoint.name }}</option>
          </select>
        </div>

        <div class="field" *ngIf="shopCompanies.length">
          <label for="report-shop-company">{{ 'ASSOCIATED_COMPANY' | translate }}</label>
          <select id="report-shop-company" class="form-select" formControlName="shopCompanyId" [disabled]="isLoading">
            <option value="">{{ 'ALL' | translate }}</option>
            <option *ngFor="let company of shopCompanies" [ngValue]="company.id">{{ company.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-actions" aria-live="polite">
        <button type="submit" class="btn btn-primary" [disabled]="isLoading || isGenerating || filtersForm.invalid">
          <span class="spinner-border spinner-border-sm" *ngIf="isLoading" aria-hidden="true"></span>
          {{ (isActivePlansReport ? 'REPORT_PREVIEW' : 'SEARCH_REPORT') | translate }}
        </button>
        <button type="button" class="btn btn-success" *ngIf="isActivePlansReport" (click)="generateAndDownloadBillingReport()" [disabled]="!canGenerateBillingReport">
          <span class="spinner-border spinner-border-sm" *ngIf="isGenerating || isExporting" aria-hidden="true"></span>
          {{ 'GENERATE_AND_DOWNLOAD' | translate }}
        </button>
        <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()" [disabled]="isLoading || isGenerating">
          {{ 'CLEAR_FILTERS' | translate }}
        </button>
      </div>
    </form>
  </section>

  <section class="status-message" *ngIf="!hasSearched && !isLoading && isSalesReport">
    {{ 'REPORT_INITIAL_STATE' | translate }}
  </section>

  <section class="status-message" *ngIf="!hasSearched && !isLoading && isActivePlansReport">
    {{ 'BILLING_REPORT_INITIAL_STATE' | translate }}
  </section>

  <section class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage | translate }}
  </section>

  <section class="alert alert-info" role="status" *ngIf="billingMessage && isActivePlansReport">
    {{ billingMessage | translate }}
  </section>

  <section class="summary-grid" *ngIf="reportResponse && isSalesReport">
    <article class="summary-card">
      <span>{{ 'TOTAL_SALES' | translate }}</span>
      <strong>{{ numberValue(summary.totalSales) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_CLIENTS' | translate }}</span>
      <strong>{{ numberValue(summary.totalClients) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_ASSOCIATIONS' | translate }}</span>
      <strong>{{ numberValue(summary.totalAssociations) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_PRINCIPAL_AMOUNT' | translate }}</span>
      <strong>{{ formatMoney(summary.totalPrincipalAmount) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_NET_AMOUNT' | translate }}</span>
      <strong>{{ formatMoney(summary.totalNetAmount) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_MONTHLY_INSTALLMENT' | translate }}</span>
      <strong>{{ formatMoney(summary.totalMonthlyInstallment) }}</strong>
    </article>
  </section>

  <section class="summary-grid" *ngIf="billingReportResponse && isActivePlansReport">
    <article class="summary-card">
      <span>{{ 'TOTAL_ROWS' | translate }}</span>
      <strong>{{ numberValue(billingSummary.totalRows) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_CLIENTS' | translate }}</span>
      <strong>{{ numberValue(billingSummary.totalClients) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_ASSOCIATIONS' | translate }}</span>
      <strong>{{ numberValue(billingSummary.totalAssociations) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_INSTALLMENT_ROWS' | translate }}</span>
      <strong>{{ numberValue(billingSummary.totalInstallmentRows) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_RECURRING_ROWS' | translate }}</span>
      <strong>{{ numberValue(billingSummary.totalRecurringRows) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_PRINCIPAL_AMOUNT' | translate }}</span>
      <strong>{{ formatMoney(billingSummary.totalPrincipalAmount) }}</strong>
    </article>
    <article class="summary-card">
      <span>{{ 'TOTAL_MONTHLY_INSTALLMENT' | translate }}</span>
      <strong>{{ formatMoney(billingSummary.totalMonthlyInstallment) }}</strong>
    </article>
  </section>

  <section class="reports-card results-card" *ngIf="hasSearched && isSalesReport">
    <div class="results-toolbar">
      <div>
        <h2>{{ 'REPORT_RESULTS' | translate }}</h2>
        <p *ngIf="validExcelRows.length || invalidExcelRows.length">
          {{ validExcelRows.length }} {{ 'VALID_EXPORT_ROWS' | translate }}
          <span *ngIf="invalidExcelRows.length"> · {{ invalidExcelRows.length }} {{ 'INVALID_EXPORT_ROWS' | translate }}</span>
        </p>
      </div>
      <button type="button" class="btn btn-success" (click)="downloadExcel()" [disabled]="!canDownloadExcel">
        {{ isExporting ? ('GENERATING_FILE' | translate) : ('DOWNLOAD_EXCEL' | translate) }}
      </button>
    </div>

    <div class="alert alert-warning" *ngIf="invalidExcelRows.length">
      {{ invalidExcelRows.length }} {{ 'INVALID_EXPORT_ROWS_DETAIL' | translate }}
    </div>

    <div class="loading" *ngIf="isLoading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="status-message" *ngIf="!isLoading && hasSearched && !previewRows.length">
      {{ 'NO_REPORT_RESULTS' | translate }}
    </div>

    <div class="table-responsive" *ngIf="!isLoading && previewRows.length">
      <table class="table table-bordered table-hover">
        <thead>
          <tr>
            <th>{{ 'IDENTIFICATION' | translate }}</th>
            <th>{{ 'CLIENT' | translate }}</th>
            <th>{{ 'ORDER' | translate }}</th>
            <th>{{ 'DATE' | translate }}</th>
            <th>{{ 'ASSOCIATION' | translate }}</th>
            <th>{{ 'PRINCIPAL_AMOUNT' | translate }}</th>
            <th>{{ 'TERM_MONTHS' | translate }}</th>
            <th>{{ 'FIRST_INSTALLMENT_DATE' | translate }}</th>
            <th>{{ 'MONTHLY_INSTALLMENT' | translate }}</th>
            <th>{{ 'OBSERVATIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let sale of pagedSales">
            <td>{{ sale.identification }}</td>
            <td>{{ sale.client }}</td>
            <td>{{ sale.order }}</td>
            <td>{{ formatDate(sale.date) }}</td>
            <td>{{ sale.association }}</td>
            <td>{{ formatMoney(sale.principalAmount) }}</td>
            <td>{{ sale.termMonths || '-' }}</td>
            <td>{{ formatDate(sale.firstInstallmentDate) }}</td>
            <td>{{ formatMoney(sale.monthlyInstallment) }}</td>
            <td class="observations" [title]="sale.observations" tabindex="0">{{ sale.observations }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-toolbar" *ngIf="previewRows.length">
      <label for="report-page-size">{{ 'RECORDS' | translate }}</label>
      <select id="report-page-size" class="form-select" [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)">
        <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
      </select>
      <button type="button" class="btn btn-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">{{ 'PREVIOUS' | translate }}</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button type="button" class="btn btn-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">{{ 'NEXT' | translate }}</button>
    </div>
  </section>

  <section class="reports-card results-card" *ngIf="hasSearched && isActivePlansReport">
    <div class="results-toolbar">
      <div>
        <h2>{{ 'REPORT_RESULTS' | translate }}</h2>
      </div>
    </div>

    <div class="loading" *ngIf="isLoading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="status-message" *ngIf="!isLoading && hasSearched && !billingRows.length">
      {{ 'NO_REPORT_RESULTS' | translate }}
    </div>

    <div class="table-responsive" *ngIf="!isLoading && billingRows.length">
      <table class="table table-bordered table-hover billing-table">
        <thead>
          <tr>
            <th>{{ 'IDENTIFICATION' | translate }}</th>
            <th>{{ 'CLIENT' | translate }}</th>
            <th>{{ 'PRODUCT' | translate }}</th>
            <th>{{ 'CODE' | translate }}</th>
            <th>{{ 'BILLING_TYPE' | translate }}</th>
            <th>{{ 'ORDER' | translate }}</th>
            <th>{{ 'DATE' | translate }}</th>
            <th>{{ 'ASSOCIATION' | translate }}</th>
            <th>{{ 'QUANTITY' | translate }}</th>
            <th>{{ 'PRINCIPAL_AMOUNT' | translate }}</th>
            <th>{{ 'TERM_MONTHS' | translate }}</th>
            <th>{{ 'MONTHLY_INSTALLMENT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedBillingRows">
            <td>{{ row.clientNationalId || '-' }}</td>
            <td>{{ row.clientFullName || '-' }}</td>
            <td>{{ row.productName || '-' }}</td>
            <td>{{ row.productCode || '-' }}</td>
            <td>{{ billingTypeLabel(row.billingType) | translate }}</td>
            <td>{{ row.saleOrderCode || '-' }}</td>
            <td>{{ formatDate(row.saleDateOnly) }}</td>
            <td>{{ row.shopCompanyName || '-' }}</td>
            <td>{{ row.quantity || '-' }}</td>
            <td>{{ formatMoney(row.principalAmount) }}</td>
            <td>{{ row.termMonths || '-' }}</td>
            <td>{{ formatMoney(row.monthlyInstallment) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination-toolbar" *ngIf="billingRows.length">
      <label for="billing-report-page-size">{{ 'RECORDS' | translate }}</label>
      <select id="billing-report-page-size" class="form-select" [value]="pageSize" (change)="onPageSizeChange($any($event.target).value)">
        <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
      </select>
      <button type="button" class="btn btn-link" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">{{ 'PREVIOUS' | translate }}</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button type="button" class="btn btn-link" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">{{ 'NEXT' | translate }}</button>
    </div>
  </section>

  <section class="reports-card history-card" *ngIf="isActivePlansReport">
    <div class="results-toolbar">
      <div>
        <h2>{{ 'REPORT_HISTORY_TITLE' | translate }}</h2>
      </div>
    </div>

    <section class="alert alert-warning" role="alert" *ngIf="historyErrorMessage">
      {{ historyErrorMessage | translate }}
    </section>

    <div class="loading" *ngIf="isHistoryLoading">
      <div class="spinner-border" role="status"></div>
    </div>

    <div class="status-message" *ngIf="!isHistoryLoading && !billingHistory.length">
      {{ 'NO_REPORT_RESULTS' | translate }}
    </div>

    <div class="table-responsive" *ngIf="!isHistoryLoading && billingHistory.length">
      <table class="table table-bordered table-hover history-table">
        <thead>
          <tr>
            <th>{{ 'REPORT_ID' | translate }}</th>
            <th>{{ 'BILLING_PERIOD' | translate }}</th>
            <th>{{ 'CREATED_AT' | translate }}</th>
            <th>{{ 'USER' | translate }}</th>
            <th>{{ 'TOTAL_ROWS' | translate }}</th>
            <th>{{ 'TOTAL_PRINCIPAL_AMOUNT' | translate }}</th>
            <th>{{ 'TOTAL_MONTHLY_INSTALLMENT' | translate }}</th>
            <th>{{ 'ACTIONS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let report of billingHistory">
            <td>{{ report.billingReportId }}</td>
            <td>{{ report.billingPeriod || '-' }}</td>
            <td>{{ formatDate(report.createdAt) }}</td>
            <td>{{ report.createdBy || '-' }}</td>
            <td>{{ numberValue(report.totalRows) }}</td>
            <td>{{ formatMoney(report.totalPrincipalAmount) }}</td>
            <td>{{ formatMoney(report.totalMonthlyInstallment) }}</td>
            <td>
              <button type="button" class="btn btn-link history-download" (click)="downloadBillingHistoryReport(report)" [disabled]="isExporting || isGenerating">
                {{ 'DOWNLOAD_AGAIN' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</main>

<app-footer></app-footer>
